import { caretDownIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const CaretDown = createIcon({
  displayName: 'CaretDown',
  paths: [
    'M266.637 412.107l204.629 233.858c17.024 19.456 47.232 19.456 64.213 0l204.672-233.858c24.149-27.605 4.523-70.784-32.128-70.784h-409.301c-36.608 0-56.235 43.179-32.085 70.784z'
  ],
  canvasPaths: canvasIconPaths(caretDownIcon)
})
